import { createContext } from 'react'
import { useStore } from 'zustand'
import { TreeStore, TreeStoreType } from './store/tree-store'
import { useRequiredContext } from '../../../../utils/use-required-context'

export const TreeStoreContext = createContext<TreeStore | null>(null)

export const useTreeStoreInstance = () => useRequiredContext(TreeStoreContext)

export function useTreeStore<T>(selector: (state: TreeStoreType) => T) {
  const treeStore = useTreeStoreInstance()
  return useStore(treeStore, selector)
}

export function useTreeData() {
  return useTreeStore(st => st.treeData)
}

export function useTreeActions() {
  return useTreeStore(st => st.actions)
}
